import { Component } from '@angular/core';

@Component({
  selector: 'app-page-bar',
  templateUrl: './page-bar.component.html',
  styleUrls: ['./page-bar.component.scss']
})
export class PageBarComponent {

  constructor() { }

}
